export enum Feature {
    USER_INTERFACE = 'user_interface',
    SUPERVISION_ROOMS = 'supervision_rooms',
    USB_DEVICE_AGENT = 'usb_device_agent',
    WEBCAM = 'webcam',
}
